import {
  ScopeOfPracticeEnum,
  ShiftTypeEnum,
  TimeString
} from '@umss/shared/utils';

export interface CreateShiftNeedDto {
  facilityId: string; // Guid in backend
  facilitySubtypeId?: number | null;
  scopeOfPractice: ScopeOfPracticeEnum;
  description?: string | null; // Max length: 1000
  shiftType: ShiftTypeEnum;
  shiftDate: string; // DateOnly in backend - ISO date format: YYYY-MM-DD
  startTime: TimeString; // TimeOnly in backend - Time format: HH:mm or HH:mm:ss
  endTime: TimeString; // TimeOnly in backend - Time format: HH:mm or HH:mm:ss
  numberOfPositions: number; // Default: 1, Range: 1-10
  hourlyRate?: number | null; // Decimal in backend, Range: 15.00-500.00
  specialInstructions?: string | null; // Max length: 1000
  expiresAt?: string | null; // DateTime in backend - ISO datetime format
  isUrgent: boolean; // Default: false
  isRecurring: boolean; // Default: false
  recurringPatternId?: number | null;
  allowEarlyClockIn?: boolean; // Default: false
  allowLateClockOut?: boolean; // Default: false
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type, @typescript-eslint/no-empty-interface
export interface UpdateShiftNeedDto extends Omit<
  CreateShiftNeedDto,
  'facilityId'
> {}
